// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"ff0fe26f","737":"27493dbc","957":"38af6c36"}[chunkId] + ".js";
};